<template>
  <div id="app">
    <div v-if="path !== '/auth'" class="header">
      <router-link to="/" class="name">RepFinder</router-link>
      <span class="actions">
        <span v-if="path === '/'" class="region">
          <!-- <label for='region_selecgor'>Region:</label> -->
          <select v-model="region" id="region__selector">
            <option value="">Select Region</option>
            <option value="ak">Alaska</option>
            <option value="can">Canada</option>
            <option value="co">Colorado</option>
            <option value="hi">Hawaii</option>
            <option value="id">Idaho</option>
            <option value="mt">Montana</option>
            <option value="or">Oregon</option>
            <option value="tx">Texas</option>
            <option value="wa">Washington</option>
            <option value="wy">Wyoming</option>
          </select>
        </span>
        <span @click="menu = !menu" v-if="user" class="user">
          <div v-bind:style="{ backgroundImage : `url(${user.photo})`}" class="user__img"></div>
        </span>
      </span>
      <div class="menu" v-if="menu">
        <span v-if="user.email === 'd.shafer@bargreen.com' || user.email === 's.lotts@bargreen.com'" @click="navFactories" to="/factories">Manage Factories</span>
        <span v-if="user.email === 'd.shafer@bargreen.com' || user.email === 's.lotts@bargreen.com'" @click="navReps" to="/reps">Manage Reps</span>
        <span>
          <a href="mailto:s.lotts@bargreen.com?subject=Repfinder Suggested Edit&body=Hi Stephanie, I would like to recommend the following change to the Repfinder:">Suggest an Edit</a>
        </span>
        <span @click="navAuth" to="/auth">Sign Out</span>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
import {store} from '@/store'
import router from '@/router'
export default {
  name: 'App',
  data: function(){
    return {
      menu: true
    }
  },
  computed: {
    user: function(){
      return store.state.user
    },
    region: {
      get(){
        return store.state.region
      },
      set(val){
        store.commit('setregion', val)
        store.dispatch('setRepGroup')
      }
    },
    path: function(){
      return this.$route.path
    }
  },
  mounted: function() {
    if(localStorage.repregion) {
      store.commit('setregion', localStorage.repregion)
      this.menu = false
    }
  },
  methods: {
    navFactories: function(){
      this.menu = false
      router.push('/factories')
    },
    navReps: function(){
      this.menu = false
      router.push('/reps')
    },
    navAuth: function(){
      this.menu = false
      store.dispatch('signOut')
    }
  }
}
</script>

<style lang="less">
.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
a {
  color: #1882e6;
  text-decoration: none;
  font-weight: bold;
}

select {
  -webkit-appearance: none;
  -moz-appearance:    none;
  border: solid 2px;
  color: white;
  background: transparent;
  border-radius: 3px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: bold;
  margin-right: 12px;
}

body {
  margin: 0px;
}
#app {
  font-family: 'Roboto', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
.header {
  display: flex;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
  background-color: #1882e6;
  color: white;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px;
  box-sizing: border-box;
  &:extend(.shadow);
  z-index: 3000;
  .name {
    font-size: 1.5em;
    font-weight: bold;
    color: white;
  }
}



label {
  font-size: 0.8em;
  text-transform: uppercase;
  font-weight: bold
}

.user__img {
  height: 40px;
  width: 40px;
  border: solid 2px;
  border-radius: 50%;
  background-size: cover;
}

.actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}

.menu {
  display: block;
  position: fixed;
  top: 66px;
  right: 24px;
  border-radius: 3px;
  background-color: white;
  &:extend(.shadow);
  span{
    padding: 12px 24px;
    box-sizing: border-box;
    border-bottom: dashed 1px lightgray;
    display: block;
    cursor: pointer;
    color: #333333;
    font-weight: bold;
    font-size: 0.8em;
    &:last-child {
      border-bottom: none;
    }
  }
}

option{
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/App.vue